import FacebookIcon from "@mui/icons-material/Facebook";
const faceBookIconStyles = {
  width: '16px',
  height: '16px',
  marginRight: '5px'
}

export const HeaderLinksDesktop = [
  {
    title: "about",
    link: "https://cotown.eu/about",
  },
  {
    title: "contact",
    link: "https://cotown.eu/contact",
  },
  {
    title: "Facebook",
    link: "https://www.facebook.com/profile.php?id=61552642923441",
    icon: <FacebookIcon style={faceBookIconStyles} />
  }
  
];


export const HeaderLinks = [
  {
    title: "about",
    link: "https://cotown.eu/about",
  },
  {
    title: "contact",
    link: "https://cotown.eu/contact",
  }
];
